export enum SessionStorageEnum {
  PARTNER_ID = "PARTNER_ID"
}